import React, { useRef, useState, useEffect } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function SignaturePad({ signerName, onSign }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [typed, setTyped] = useState(signerName || "");
  const [name, setName] = useState(signerName || "");

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.strokeStyle = "#18181A";
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const cx = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const cy = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    return { x: cx, y: cy };
  };
  const start = (e) => {
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
  };
  const end = () => (drawing.current = false);
  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
  };

  const submitDrawn = () => {
    const data = canvasRef.current.toDataURL("image/png");
    onSign(name, data);
  };
  const submitTyped = () => {
    const c = document.createElement("canvas");
    c.width = 500;
    c.height = 140;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#18181A";
    ctx.font = "42px 'Segoe Script', cursive";
    ctx.fillText(typed || name, 20, 90);
    onSign(name, c.toDataURL("image/png"));
  };

  return (
    <div className="space-y-3">
      <div>
        <Label className="overline">Signer name</Label>
        <Input data-testid="signer-name-input" value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5" />
      </div>
      <Tabs defaultValue="draw">
        <TabsList className="w-full">
          <TabsTrigger value="draw" className="flex-1" data-testid="sig-tab-draw">Draw</TabsTrigger>
          <TabsTrigger value="type" className="flex-1" data-testid="sig-tab-type">Type</TabsTrigger>
        </TabsList>
        <TabsContent value="draw">
          <div className="border border-dashed border-border rounded-md bg-secondary/40">
            <canvas
              data-testid="signature-canvas"
              ref={canvasRef}
              width={460}
              height={150}
              className="w-full touch-none cursor-crosshair"
              onMouseDown={start}
              onMouseMove={move}
              onMouseUp={end}
              onMouseLeave={end}
              onTouchStart={start}
              onTouchMove={move}
              onTouchEnd={end}
            />
          </div>
          <div className="flex gap-2 mt-3">
            <Button variant="outline" onClick={clear} className="flex-1" data-testid="sig-clear">Clear</Button>
            <Button onClick={submitDrawn} className="flex-1" data-testid="sig-submit-drawn">Sign & Save</Button>
          </div>
        </TabsContent>
        <TabsContent value="type">
          <Input
            data-testid="typed-signature-input"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder="Type your full name"
            className="text-2xl h-16"
            style={{ fontFamily: "'Segoe Script', cursive" }}
          />
          <Button onClick={submitTyped} className="w-full mt-3" data-testid="sig-submit-typed">Sign & Save</Button>
        </TabsContent>
      </Tabs>
    </div>
  );
}
